// @flow

import React, { type Node } from 'react';

import { Padding, SectionTitle, HighlightBox, Separator } from '../../../../commons/atoms';
import { List, ListItem } from '../.././../../commons/molecules';

export function SpeiInstructions(): Node {
  return (
    <section>
      <HighlightBox>
        <Padding value="1em">
          <SectionTitle>Consejos de Pago!</SectionTitle>
          <Separator size="1em" />
          <List>
            <ListItem>
              Ingresa a tu banca en línea y registra la CLABE interbancaria que aparece en la boleta. Puede demorar
              hasta 24 horas para que la CLABE quede registrada.
            </ListItem>
            <ListItem>
              Para garantizar tu pago, digita el número de referencia y el total a pagar tal y como aparece en tu
              boleta.
            </ListItem>
            <ListItem>
              Identifica como banco destino a Sistema de transferencia de pagos (STP) y a EBANX como beneficiario.
            </ListItem>
            <ListItem>Confirma los datos y realiza la transferencia.</ListItem>
          </List>
        </Padding>
      </HighlightBox>
    </section>
  );
}
